import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ConnectFailedAmazonButton({ className = "" }) {
  const [err, setErr] = useState("");
  const nav = useNavigate();

  const { spid, corr, reason, detail, error, errorDesc } = useMemo(() => {
    try {
      const p = new URLSearchParams(window.location.search);
      return {
        spid: p.get("spid") || "",
        corr: p.get("corr") || "",
        reason: p.get("reason") || "",
        detail: p.get("detail") || "",
        // If Amazon redirects with OAuth error params directly
        error: p.get("error") || "",
        errorDesc: p.get("error_description") || "",
      };
    } catch {
      return {
        spid: "",
        corr: "",
        reason: "",
        detail: "",
        error: "",
        errorDesc: "",
      };
    }
  }, []);

  // If user lands here without any context, keep it but show guidance
  useEffect(() => {
    if (!reason && error) {
      // normalize amazon error into reason/detail
      const qs = new URLSearchParams({
        spid,
        corr,
        reason: error,
        detail: errorDesc,
      }).toString();
      nav(`/connect-failed?${qs}`, { replace: true });
    }
  }, [reason, error, errorDesc, spid, corr, nav]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
      }}
    >
      <div style={{ width: "100%", maxWidth: 600 }}>
        <div
          className={className}
          style={{
            width: "100%",
            padding: 24,
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
            background: "#fff",
          }}
        >
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>
            Connection failed
          </h1>

          <p style={{ fontSize: 16, color: "#555", marginTop: 12 }}>
            The Amazon authorization flow did not complete successfully.
          </p>

          <div style={{ marginTop: 12, fontSize: 14, color: "#444" }}>
            <div>
              <b>Reason:</b> {reason || error || "(not provided)"}
            </div>
            {(detail || errorDesc) && (
              <div style={{ marginTop: 6 }}>
                <b>Details:</b> {detail || errorDesc}
              </div>
            )}
          </div>

          <div style={{ marginTop: 16 }}>
            <label style={{ fontSize: 12, color: "#666" }}>YOUR SPID</label>
            <code
              style={{
                display: "block",
                marginTop: 6,
                padding: "8px 10px",
                background: "#f5f5f5",
                borderRadius: 6,
                fontSize: 14,
                wordBreak: "break-all",
              }}
            >
              {spid || "(missing)"}
            </code>
          </div>

          <div style={{ marginTop: 16 }}>
            <label style={{ fontSize: 12, color: "#666" }}>REF (corr)</label>
            <code
              style={{
                display: "block",
                marginTop: 6,
                padding: "8px 10px",
                background: "#f5f5f5",
                borderRadius: 6,
                fontSize: 14,
                wordBreak: "break-all",
              }}
            >
              {corr || "(missing)"}
            </code>
          </div>

          <p style={{ fontSize: 14, color: "#777", marginTop: 14 }}>
            Please retry the connection. If the issue persists, share the{" "}
            <b>corr</b> value with the IT team for troubleshooting.
          </p>

          {err && (
            <div
              role="alert"
              style={{
                color: "crimson",
                marginTop: 12,
                background: "#fff1f2",
                border: "1px solid #fecdd3",
                padding: 10,
                borderRadius: 8,
              }}
            >
              {err}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
